import { render, staticRenderFns } from "./DaftarGuru.vue?vue&type=template&id=3231f3e0&scoped=true"
import script from "./DaftarGuru.vue?vue&type=script&lang=js"
export * from "./DaftarGuru.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3231f3e0",
  null
  
)

export default component.exports